/*eslint-disable*/
import { useState, useEffect, useContext } from 'react';
import ListHeader from '../SectionHeader';
import TablePagination from '../TablePaginationComponent';
import useFetchData from '../../hooks/useFetchData';
import useSort from '../../hooks/useSort';
import Filter from '../Filter';
import { ReactComponent as SortIcon } from '../../assets/images/sort.svg';
import { useNavigate } from 'react-router-dom';
import SnackBar from 'components/SnackBar';
import translating from './translate.json';
import GlobalContext from '../../contexts';
import useCustomForm from 'hooks/useCustomForm';
import { random } from 'lodash';
import usePostData from 'hooks/usePostData';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

import './styles.scss';
import ExcelDownload from 'components/ExcelDownload';

const PredibetesOrgDashboard = () => {
  const navigate = useNavigate();
  const { res, postData } = usePostData();
  const [data, setData] = useState([]);
  const { organizationsList } = useContext(GlobalContext);
  const { showFilters } = useSort();
  const [excelData, setExcelData] = useState([]);

  const [loading, setLoading] = useState(false);

  const tableHeadersClients = [
    translating.clientName,
    'גיל',
    'מגדר',
    'האם מעשן',
    'עישנתי בעבר',
    'שעות שינה',
    'תזונה',
    'פעילות גופנית',
    'BMI',
    'AC1',
    'NON HDL',
    'לחץ דם'
  ];

  const columnsClients = [
    {
      value: 'clientFullName',
      sort: true
      // label: translating.clientName
    },
    { value: 'age', sort: true },
    { value: 'gender', sort: true },
    { value: 'isSmoker', sort: true },
    { value: 'isSmoked', sort: true },
    { value: 'sleepHours', sort: true },
    { value: 'nutrition_C1_count', sort: true },
    { value: 'exercise', sort: true },
    { value: 'BMI', sort: true },
    { value: 'A1C', sort: true },
    { value: 'non_hdl', sort: true },
    { value: 'bloodPress', sort: true }
  ];

  const [sortFields, setSortFields] = useState();

  const onFilter = (filteredData) => {
    setFilteredCustomers(filteredData);
  };

  const onResetFilters = () => {
    setData([]);
  };

  useEffect(() => {
    if (res) {
      setLoading(false);
      setData(res);
      const formattedExcelData = res.map((item) => {
        return {
          'שם לקוח': item.clientFullName,
          גיל: item.age,
          מגדר: item.gender,
          'האם מעשן': item.isSmoker,
          'האם עישנתי בעבר': item.isSmoked,
          'שעות שינה': `${item.sleepHours} שעות`,
          תזונה: item.nutrition_C1_count,
          'פעילות גופנית': item.exercise,
          BMI: item.BMI,
          A1C: item.A1C,
          non_hdl: item.non_hdl,
          'לחץ דם': item.bloodPress
        };
      });
      setExcelData(formattedExcelData);
    }
  }, [res]);

  const handleServerFilter = (filters) => {
    setLoading(true);
    postData('client-product/dashboard/predibitesOrgDashboard', filters);
  };

  const fields = [
    {
      type: 'multiselect',
      label: translating.organization,
      name: 'orgIds',
      options: organizationsList,
      isId: true
    }
  ];

  useEffect(() => {
    if (organizationsList?.length) {
      setSortFields([]);
      setTimeout(() => {
        setSortFields(fields);
      }, 0);
    }
  }, [organizationsList]);

  // useEffect(() => {
  //   if (
  //     watchFilters.productId &&
  //     watchFilters.productId !== 'all' &&
  //     watchFilters.productId !== currentProduct
  //   ) {
  //     currentProduct = watchFilters.productId;
  //     let productInfo = productsList.find(
  //       (p) => p.id === watchFilters.productId
  //     );
  //     let id;
  //     if (productInfo.id < 4) id = productInfo.id;
  //     else id = productInfo.parentId;
  //     let s = steppersData.filter((s) => s.productId === id);
  //     setCurrentSteppersData(s);
  //   } else if (watchFilters.productId === 'all') setCurrentSteppersData([]);
  // }, [watchFilters.productId]);

  return (
    <div className="report-list">
      <div className="wrapper-header">
        <ListHeader title={'דשבורד לארגון'}></ListHeader>
        {data && data.length ? (
          <ExcelDownload
            data={excelData}
            filename={'orgDashboard.csv'}
          ></ExcelDownload>
        ) : null}
      </div>
      {/* {showFilters && renderForm()} */}
      <Filter
        fields={sortFields}
        data={data}
        handleFilter={onFilter}
        handleReset={onResetFilters}
        ssf={handleServerFilter}
      ></Filter>
      {loading ? (
        <Box sx={{ display: 'flex' }} className="loading">
          <CircularProgress />
        </Box>
      ) : (
        data && (
          <>
            <div className="count-clients">{`נמצאו ${data?.length} רשומות `}</div>
            <div className="customers-list-wrapper-table">
              {organizationsList && organizationsList.length && (
                <TablePagination
                  headers={tableHeadersClients}
                  columns={columnsClients}
                  rows={data}
                  pagination={true}
                  useUId={true}
                  handleRowClick={(id) => {
                    navigate(`/clients/${id}`);
                  }}
                ></TablePagination>
              )}
            </div>
          </>
        )
      )}
    </div>
  );
};

export default PredibetesOrgDashboard;
